import { Blocs } from '@business/blocs';
import { OrderStatus } from '@business/entities/order';
import { OrgId } from '@business/entities/organization';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, combineLatest, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrdersFilterData } from './Orders';

export class OrdersBloc extends BaseBloc {
  private readonly orderBloc = resolve(Blocs.order);
  private readonly stageBloc = resolve(Blocs.orderStage);
  loading = new LoadingState();

  constructor(private readonly orgId: OrgId) {
    super();
  }

  filters$ = new BehaviorSubject<OrdersFilterData>({ status: OrderStatus.open, stage: '' });
  orders$ = this.orderBloc.orders$;
  stages$ = this.stageBloc.stages$;

  readonly filteredOrders$ = combineLatest(this.filters$, this.orders$).pipe(
    map(([filters, orders]) => {
      return orders.filter(o => {
        if (filters.status && filters.status !== o.status) {
          return false;
        }

        if (filters.stage && filters.stage !== o.stage.id) {
          return false;
        }
        return true;
      });
    }),
  );

  onInit() {
    return forkJoin([this.orderBloc.fetchOrgOrders(this.orgId), this.stageBloc.fetchStages()]).pipe(this.loading.run());
  }

  updateStatus = this.orderBloc.updateStatus;
}
